import { render, staticRenderFns } from "./chateau-pape-clement.vue?vue&type=template&id=02a28348&scoped=true"
import script from "./chateau-pape-clement.vue?vue&type=script&lang=js"
export * from "./chateau-pape-clement.vue?vue&type=script&lang=js"
import style0 from "./chateau-pape-clement.vue?vue&type=style&index=0&id=02a28348&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02a28348",
  null
  
)

export default component.exports